export enum InventoryType {
  REUSE = "REUSE",
  RECYCLING = "RECYCLING",
}
